import { render, staticRenderFns } from "./LayoutSavitarna.vue?vue&type=template&id=226b6e12&scoped=true&"
import script from "./LayoutSavitarna.vue?vue&type=script&lang=js&"
export * from "./LayoutSavitarna.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSavitarna.vue?vue&type=style&index=0&id=226b6e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b6e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VApp,VMain,VSheet})
